// 获取设置的公告和通知
import { request } from "@/utils/request.js";
import { axiosEnum, axiosEnum_JDWX } from "./enum";

const FEST_URL = axiosEnum_JDWX[process.env.VUE_APP_API_ENV];

/**
 * 获取公告列表
 * @param {Number} pageNo 页码
 * @param {Number} pageSize 每页条数
 * @param {String} keyWord 标题
 * @param {String} status 状态 // T-显示，F-隐藏
 * @param {String} type 类型 // 16-更新公告
 */
export function getNoticeList(param) {
    return request("/notice/list", "get", param, {
        baseURL: FEST_URL,
    });
}

/**
 * 获取公告详情
 * @param {Number} id 公告id
 */
export function getNoticeById(param) {
    return request("/notice/info", "get", param, {
        baseURL: FEST_URL,
    });
}
